import React from 'react';

const InstagramIcon = ({ className }) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <rect width='24' height='24' rx='12' fill='url(#paint0_radial_579_86622)' fillOpacity='0.9' />
            <rect width='24' height='24' rx='12' fill='url(#paint1_radial_579_86622)' fillOpacity='0.9' />
            <rect width='24' height='24' rx='12' fill='url(#paint2_radial_579_86622)' fillOpacity='0.9' />
            <path
                d='M17.4 7.7572C17.4 8.39627 16.8819 8.91434 16.2428 8.91434C15.6038 8.91434 15.0857 8.39627 15.0857 7.7572C15.0857 7.11812 15.6038 6.60005 16.2428 6.60005C16.8819 6.60005 17.4 7.11812 17.4 7.7572Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 15.8572C14.1302 15.8572 15.8571 14.1303 15.8571 12.0001C15.8571 9.86981 14.1302 8.14291 12 8.14291C9.86975 8.14291 8.14285 9.86981 8.14285 12.0001C8.14285 14.1303 9.86975 15.8572 12 15.8572ZM12 14.3143C13.2781 14.3143 14.3143 13.2782 14.3143 12.0001C14.3143 10.7219 13.2781 9.68577 12 9.68577C10.7218 9.68577 9.68571 10.7219 9.68571 12.0001C9.68571 13.2782 10.7218 14.3143 12 14.3143Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.28571 11.6915C4.28571 9.09924 4.28571 7.80312 4.79019 6.81301C5.23395 5.94209 5.94203 5.23401 6.81295 4.79025C7.80306 4.28577 9.09918 4.28577 11.6914 4.28577H12.3086C14.9008 4.28577 16.1969 4.28577 17.187 4.79025C18.058 5.23401 18.766 5.94209 19.2098 6.81301C19.7143 7.80312 19.7143 9.09924 19.7143 11.6915V12.3086C19.7143 14.9009 19.7143 16.197 19.2098 17.1871C18.766 18.058 18.058 18.7661 17.187 19.2099C16.1969 19.7143 14.9008 19.7143 12.3086 19.7143H11.6914C9.09918 19.7143 7.80306 19.7143 6.81295 19.2099C5.94203 18.7661 5.23395 18.058 4.79019 17.1871C4.28571 16.197 4.28571 14.9009 4.28571 12.3086V11.6915ZM11.6914 5.82862H12.3086C13.6301 5.82862 14.5285 5.82982 15.223 5.88656C15.8994 5.94183 16.2453 6.042 16.4866 6.16495C17.0672 6.46078 17.5393 6.93284 17.8351 7.51345C17.958 7.75476 18.0582 8.10067 18.1135 8.77708C18.1702 9.47151 18.1714 10.3699 18.1714 11.6915V12.3086C18.1714 13.6302 18.1702 14.5286 18.1135 15.223C18.0582 15.8994 17.958 16.2453 17.8351 16.4867C17.5393 17.0673 17.0672 17.5393 16.4866 17.8352C16.2453 17.9581 15.8994 18.0583 15.223 18.1135C14.5285 18.1703 13.6301 18.1715 12.3086 18.1715H11.6914C10.3698 18.1715 9.47144 18.1703 8.77702 18.1135C8.10061 18.0583 7.75469 17.9581 7.51339 17.8352C6.93278 17.5393 6.46072 17.0673 6.16489 16.4867C6.04194 16.2453 5.94176 15.8994 5.8865 15.223C5.82976 14.5286 5.82856 13.6302 5.82856 12.3086V11.6915C5.82856 10.3699 5.82976 9.47151 5.8865 8.77708C5.94176 8.10067 6.04194 7.75476 6.16489 7.51345C6.46072 6.93284 6.93278 6.46078 7.51339 6.16495C7.75469 6.042 8.10061 5.94183 8.77702 5.88656C9.47144 5.82982 10.3698 5.82862 11.6914 5.82862Z'
                fill='white'
            />
            <defs>
                <radialGradient
                    id='paint0_radial_579_86622'
                    cx='0'
                    cy='0'
                    r='1'
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='translate(8.57143 18) rotate(-55.3758) scale(21.8739)'
                >
                    <stop stopColor='#B13589' />
                    <stop offset='0.79309' stopColor='#C62F94' />
                    <stop offset='1' stopColor='#8A3AC8' />
                </radialGradient>
                <radialGradient
                    id='paint1_radial_579_86622'
                    cx='0'
                    cy='0'
                    r='1'
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='translate(7.71429 24.8571) rotate(-65.1363) scale(19.3665)'
                >
                    <stop stopColor='#E0E8B7' />
                    <stop offset='0.444662' stopColor='#FB8A2E' />
                    <stop offset='0.71474' stopColor='#E2425C' />
                    <stop offset='1' stopColor='#E2425C' stopOpacity='0' />
                </radialGradient>
                <radialGradient
                    id='paint2_radial_579_86622'
                    cx='0'
                    cy='0'
                    r='1'
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='translate(-1.28571 0.857143) rotate(-8.1301) scale(33.335 7.13002)'
                >
                    <stop offset='0.156701' stopColor='#406ADC' />
                    <stop offset='0.467799' stopColor='#6A45BE' />
                    <stop offset='1' stopColor='#6A45BE' stopOpacity='0' />
                </radialGradient>
            </defs>
        </svg>
    );
};

export { InstagramIcon };
